<template>
    <el-skeleton :loading="loading" :rows="16" animated>
        <el-page class="products-page" :bannerImageUrl="bannerImageUrl">
            <div class="family-funds">
                <pane-title class="pane" title="在管基金" subTitle="FUNDS UNDER MANAGEMENT" />
                <div class="funds-list">
                    <div v-for="(item, index) in fundList" :key="index" class="fund-item">
                        <div class="fund-image">
                            <img :src="item.pcImgUrl" :alt="item.title">
                        </div>
                    </div>
                </div>
            </div>
            <div class="family-funds">
                <pane-title class="pane" title="投资案例" subTitle="INVESTMENT CASES" />
                <div class="funds-list">
                    <div v-for="(item, index) in caseList" :key="index" class="fund-item">
                         <div class="fund-image">
                            <img :src="item.pcImgUrl" :alt="item.title">
                        </div>
                    </div>
                </div>
            </div>
        </el-page>
    </el-skeleton>
</template>

<script>
import PaneTitle from '../../components/PaneTitle/PaneTitle.vue';
export default {
    name: "invest",
    components: { PaneTitle },
    data() {
        return {
            loading: true,
            bannerImageUrl: null,
            fundList: [],
            caseList: []
        }
    },
    computed: {
        lang() {
            return this.$i18n.locale;
        },
        newsPageNo() {
            return Math.ceil(this.newsData.length / this.pageSize);
        },
        currentTrendsList() {
            const start = (this.currentPage - 1) * this.pageSize;
            const end = start + this.pageSize;
            return this.trendsList.slice(start, end)
        },
    },
    methods: {
        jumpDetail(item) {
            const link = item.jumpUrl;
            if (link === 'local') {
                window.open('/news-detail/' + item.id);
            } else if (link) {
                window.open(link)
            }
        },
        configData(record) {
            this.fundList = (record['41'] && record['41'] || []).sort((a, b) => a.sort - b.sort)
            this.caseList = (record['41'] && record['42'] || []).sort((a, b) => a.sort - b.sort)

        },
        getData(language) {
            this.$http.getOnlyContent({
                itemType: '4',
                platform: 'pc',
                language
            }).then(res => {
                this.loading = false;
                this.bannerImageUrl = res.imageMaps['40'] && res.imageMaps['40'][0] && res.imageMaps['40'][0].imgUrl
                this.configData(res.crmOweContentMaps)
            });
        },
        getDataByLang(lang) {
            if (lang === 'zh') {
                this.getData('china');
            } else {
                this.getData('english');
            }
        }
    },
    watch: {
        "$i18n.locale": {
            immediate: true,
            handler(v) {
                this.getDataByLang(v);
            }
        },
    }
}
</script>

<style scoped lang="less">
.products-page {
    padding-bottom: 5rem;

    .pane {
        margin: 3rem 0;
    }

    .family-funds {
        margin: 0 15rem;
    }

    .funds-list {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 1rem;
        width: 100%;
    }

    .fund-item {
        background: #FFF;
        box-shadow: 0px 4px 30px -2px rgba(13, 20, 138, 0.10);
        aspect-ratio: 469/258;
        overflow: hidden;
        cursor: pointer;
        &:hover {
            box-shadow: 0px 4px 30px -2px rgba(13, 20, 138, 0.30);
        }
        transition: box-shadow 0.3s ease;
    }

    .fund-image {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
            width: 60%;
            height: auto;
            object-fit: cover;
        }
    }
}

/* 小屏幕（移动端） */
@media screen and (max-width: 767px) {
    .products-page {
        padding-bottom: 4rem;
        .family-funds {
            margin: 0;
        }
        .funds-list {
            grid-template-columns: repeat(2, 1fr);
        }
    }
}
</style>